import { useState, useEffect } from 'react';

export default function CustomCursor() {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [outerPosition, setOuterPosition] = useState({ x: 0, y: 0 });
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let animationFrameId;

    const moveCursor = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
      setIsVisible(true);
    };

    const hideCursor = () => {
      setIsVisible(false);
    };

    const animateOuter = () => {
      setOuterPosition(prev => ({
        x: prev.x + (mousePosition.x - prev.x) * 0.35,
        y: prev.y + (mousePosition.y - prev.y) * 0.35,
      }));
      animationFrameId = requestAnimationFrame(animateOuter);
    };

    window.addEventListener('mousemove', moveCursor);
    window.addEventListener('mouseleave', hideCursor);
    animateOuter();

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      window.removeEventListener('mouseleave', hideCursor);
      cancelAnimationFrame(animationFrameId);
    };
  }, [mousePosition]);

  return (
    <>
      {/* Outer Cursor - Follows with delay */}
      <div
        className="mouseCursor cursor-outer"
        style={{
          visibility: isVisible ? 'visible' : 'hidden',
          transform: `translate(${outerPosition.x}px, ${outerPosition.y}px)`,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          borderRadius: '50%',
          textAlign: 'center',
          marginLeft: '-15px',
          marginTop: '-15px',
          width: '30px',
          height: '30px',
          border: '1px solid #3B7BFF',
          backgroundColor: '#3B7BFF',
          zIndex: 10000000,
          opacity: 0.34,
          transition: 'all 0.15s ease-out 0s',
        }}
      />

      {/* Inner Cursor - Follows mouse exactly */}
      <div
        className="mouseCursor cursor-inner"
        style={{
          visibility: isVisible ? 'visible' : 'hidden',
          transform: `translate(${mousePosition.x}px, ${mousePosition.y}px)`,
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          pointerEvents: 'none',
          borderRadius: '50%',
          textAlign: 'center',
          marginLeft: '-5px',
          marginTop: '-5px',
          width: '10px',
          height: '10px',
          zIndex: 10000001,
          opacity: 1,
          transition: 'all 0.08s ease-out 0s',
          backgroundColor: '#3B7BFF',
        }}
      />

      {/* Hide default cursor globally */}
      <style dangerouslySetInnerHTML={{ __html: `
        * {
          cursor: none !important;
        }
      `}} />
    </>
  );
}